module.exports = __webpack_public_path__ + "static/media/logo-dark.042cbff9.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/logo-dark.png
// module id = 283
// module chunks = 0